const projectUnitTypesTransformer = data => {
  data.push({ typeId: -1, id: -1, value: -1, name: "All" })
  return data?.map(item => ({ ...item, id: item?.typeId, value: item?.typeId, label: item?.name }))
}

export default projectUnitTypesTransformer
